import React, { useState } from 'react';
import { Coins } from 'lucide-react';
import type { User } from '../../types/user';

interface BettingPanelProps {
  user: User | null;
  onBetPlaced: (amount: number) => void;
  disabled?: boolean;
}

export function BettingPanel({ user, onBetPlaced, disabled }: BettingPanelProps) {
  const [betAmount, setBetAmount] = useState<number>(100);
  const maxBet = user?.points || 0;

  const handleBetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Math.min(Math.max(100, parseInt(e.target.value) || 0), maxBet);
    setBetAmount(value);
  };

  const quickBets = [100, 500, 1000, 5000];

  return (
    <div className="bg-gray-800 p-4 rounded-lg space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Coins className="w-5 h-5 text-yellow-400" />
          <span className="text-yellow-400 font-mono">
            Available: {user?.points.toLocaleString()}
          </span>
        </div>
        <div className="text-sm text-cyan-400">Min bet: 100</div>
      </div>

      <div className="flex gap-2">
        {quickBets.map(amount => (
          <button
            key={amount}
            onClick={() => setBetAmount(Math.min(amount, maxBet))}
            disabled={disabled || amount > maxBet}
            className="flex-1 px-2 py-1 bg-gray-700 rounded text-sm font-mono
              hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed
              transition-colors"
          >
            {amount.toLocaleString()}
          </button>
        ))}
      </div>

      <div className="space-y-2">
        <input
          type="range"
          min="100"
          max={maxBet}
          value={betAmount}
          onChange={handleBetChange}
          disabled={disabled}
          className="w-full"
        />
        <div className="flex gap-2">
          <input
            type="number"
            min="100"
            max={maxBet}
            value={betAmount}
            onChange={handleBetChange}
            disabled={disabled}
            className="flex-1 px-3 py-2 bg-gray-700 rounded text-right font-mono
              focus:outline-none focus:ring-2 focus:ring-yellow-500"
          />
          <button
            onClick={() => onBetPlaced(betAmount)}
            disabled={disabled || betAmount > maxBet || betAmount < 100}
            className="px-4 py-2 bg-gradient-to-r from-yellow-600 to-amber-500
              text-white rounded hover:from-yellow-500 hover:to-amber-400
              disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Place Bet
          </button>
        </div>
      </div>
    </div>
  );
}